var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("article", { staticClass: "tile is-child box detail-page tile" }, [
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-body" }, [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("multiselect", {
                class: { "is-danger": _vm.$v.reprintFilter.endDate.$error },
                attrs: {
                  "deselect-label": "Can't remove this value",
                  "show-labels": false,
                  options: _vm.gstDates,
                  loading: _vm.isGstLoading,
                  "internal-search": false,
                  searchable: false,
                  "allow-empty": true,
                  placeholder: "Select Period End Date",
                },
                on: { select: _vm.selectGstDate, remove: _vm.removeGstDate },
                model: {
                  value: _vm.selectedDate,
                  callback: function ($$v) {
                    _vm.selectedDate = $$v
                  },
                  expression: "selectedDate",
                },
              }),
              _vm.$v.reprintFilter && !_vm.$v.reprintFilter.endDate.required
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("GST period end date is required. "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedAcq,
                  expression: "selectedAcq",
                },
              ],
              staticClass: "is-checkradio is-info",
              class: { "has-background-color": _vm.selectedAcq },
              attrs: { id: "acqReport", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectedAcq)
                  ? _vm._i(_vm.selectedAcq, null) > -1
                  : _vm.selectedAcq,
              },
              on: {
                click: _vm.selectAcqReport,
                change: function ($event) {
                  var $$a = _vm.selectedAcq,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectedAcq = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectedAcq = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectedAcq = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "acqReport" } }, [
              _vm._v("Acquisitions/Supplies Reports"),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field is-horizontal" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedWithHold,
                  expression: "selectedWithHold",
                },
              ],
              staticClass: "is-checkradio is-info",
              class: { "has-background-color": _vm.selectedWithHold },
              attrs: { type: "checkbox", id: "withHold" },
              domProps: {
                checked: Array.isArray(_vm.selectedWithHold)
                  ? _vm._i(_vm.selectedWithHold, null) > -1
                  : _vm.selectedWithHold,
              },
              on: {
                click: _vm.selectWithHoldReport,
                change: function ($event) {
                  var $$a = _vm.selectedWithHold,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectedWithHold = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectedWithHold = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectedWithHold = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "withHold" } }, [
              _vm._v("With-Holding Report"),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }